import { DrdAttributeType } from "../../../../api/BrandKitApi";

// The hardcoded DiningRD attributes a brand can map icons to, per the change-order spec:
// FDA top-9 allergens + the fixed dietary tag set. The `attribute` key is the stable identifier
// persisted on the mapping; Timber normalizes DRD's actual allergen/tag strings to these keys
// on import (see normalizeDrdAttribute in AsideDiningRD).
export interface DrdAttribute {
  attribute: string;
  label: string;
  type: DrdAttributeType;
}

export const DRD_ATTRIBUTES: DrdAttribute[] = [
  // Allergens (FDA top 9)
  { attribute: "MILK", label: "Milk", type: "ALLERGEN" },
  { attribute: "EGGS", label: "Eggs", type: "ALLERGEN" },
  { attribute: "FISH", label: "Fish", type: "ALLERGEN" },
  { attribute: "SHELLFISH", label: "Shellfish", type: "ALLERGEN" },
  { attribute: "TREE_NUTS", label: "Tree Nuts", type: "ALLERGEN" },
  { attribute: "PEANUTS", label: "Peanuts", type: "ALLERGEN" },
  { attribute: "WHEAT", label: "Wheat", type: "ALLERGEN" },
  { attribute: "SOYBEANS", label: "Soybeans", type: "ALLERGEN" },
  { attribute: "SESAME", label: "Sesame", type: "ALLERGEN" },
  // Dietary tags
  { attribute: "FRESH", label: "Fresh", type: "TAG" },
  { attribute: "GLUTEN_FREE", label: "Gluten Free", type: "TAG" },
  { attribute: "HIGH_FIBER", label: "High Fiber", type: "TAG" },
  { attribute: "HEART_HEALTHY", label: "Heart Healthy", type: "TAG" },
  { attribute: "MIND", label: "MIND", type: "TAG" },
  { attribute: "PESCETARIAN", label: "Pescetarian", type: "TAG" },
  { attribute: "VEGAN", label: "Vegan", type: "TAG" },
  { attribute: "VEGETARIAN", label: "Vegetarian", type: "TAG" },
];
